import { defaultRightMargin } from "./constants";
import { numberFormatters } from "common";
import { NumberFormatKind } from "common/types";
import { CommmonFormatEnum } from "datapoints";
import { ChartSelectValueFormatKind, DataGranularityType, DisplayValueType } from "store/current-dashboard/types";
export const labelFormatter = (context, { width, masterDetailChoiceIndex, childrenId }) => {
    const renderedWidth = width - defaultRightMargin;
    const selectedClass = childrenId && context.pos === masterDetailChoiceIndex ? "selected" : "";
    const disabledClass = childrenId ? "" : "disabled";
    return `<div style="width:${renderedWidth + 1}px;" class="labelName ${selectedClass}${disabledClass}">${context.value}</div>`;
};
export const getDataLabelDisplayValue = (context, displayKind, displayValueType) => {
    if (displayKind === ChartSelectValueFormatKind.percent) {
        return numberFormatters(context.y, NumberFormatKind.percent, { maximumFractionDigits: 2 });
    }
    else if (displayKind === ChartSelectValueFormatKind.multiple) {
        return numberFormatters(context.y, NumberFormatKind.multiple, { minimumFractionDigits: 2 });
    }
    else if (displayValueType === DisplayValueType.Percent) {
        if (context.point?.options?.custom?.percentageOfTotal) {
            return numberFormatters(context.point.options.custom.percentageOfTotal, NumberFormatKind.percent, { maximumFractionDigits: 1 });
        }
        return numberFormatters(context.y, NumberFormatKind.percent, { maximumFractionDigits: 1 });
    }
    else if (displayKind === ChartSelectValueFormatKind.value) {
        return numberFormatters(context.y, NumberFormatKind.compact);
    }
    return numberFormatters(context.y, NumberFormatKind.compact, { maximumFractionDigits: 1 });
};
export const dataLabelFormatter = (context, displayKind, displayValueType) => {
    const display = getDataLabelDisplayValue(context, displayKind, displayValueType);
    return `<div class="labelName">${display}</div>`;
};
export const yAxisFormatter = (context, sum, aggregateType, includesNegative, displayValueType, displayKind, showVariationPercentData) => {
    if (typeof context.value === "number") {
        let numberFormatKind = displayValueType === DisplayValueType.Percent ? NumberFormatKind.percent : NumberFormatKind.default;
        let { value } = context;
        if (displayValueType === DisplayValueType.Percent && !showVariationPercentData) {
            value /= sum;
        }
        else if ((aggregateType === "Sum" && displayKind !== ChartSelectValueFormatKind.percent) || (showVariationPercentData && displayValueType !== DisplayValueType.Percent)) {
            numberFormatKind = NumberFormatKind.compact;
        }
        return `<div class="yAxisLabel">${numberFormatters(value, numberFormatKind, { maximumFractionDigits: numberFormatKind === NumberFormatKind.percent ? 1 : 2,
            signDisplay: includesNegative || aggregateType === "Variation" ? "exceptZero" : "auto" })}</div>`;
    }
    return context.axis.defaultLabelFormatter.call(context);
};
export const yAxisFormatter2 = (context, includesNegative, granularityType, format, total) => {
    if (typeof context.value === "number") {
        let { value } = context;
        let numberFormatKind = NumberFormatKind.compact;
        if (format === CommmonFormatEnum.multiple) {
            numberFormatKind = NumberFormatKind.multiple;
        }
        else if (format === CommmonFormatEnum.percent) {
            if (total) {
                value /= total;
            }
            numberFormatKind = NumberFormatKind.percent;
        }
        return `<div class="yAxisLabel">${numberFormatters(value, numberFormatKind, { maximumFractionDigits: numberFormatKind === NumberFormatKind.percent ? 1 : 2,
            signDisplay: includesNegative || granularityType === DataGranularityType.Variation ? "exceptZero" : "auto" })}</div>`;
    }
    return context.axis.defaultLabelFormatter.call(context);
};
